module.exports = __webpack_public_path__ + "img/photo.26fd0fc1.svg";